var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_61",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("g", { attrs: { id: "stxzHm" } }, [
        _c("path", {
          staticStyle: {
            fill: "none",
            stroke: "#000",
            "stroke-miterlimit": "10",
            "stroke-width": "2px",
          },
          attrs: {
            d: "m64.385,51.486l-1.83,35.59c-.06,1.07-.93,1.9-2,1.9h-21.11c-1.06,0-1.94-.83-2-1.9l-1.83-35.59c-.13-2.63.73-5.22,2.42-7.24l7.28-9.22c.28-.35.43-.79.43-1.24V11.206c0-.552.448-1,1-1h6.51c.552,0,1,.448,1,1v22.58c0,.45.15.89.43,1.24l7.28,9.22c1.69,2.02,2.55,4.61,2.42,7.24Z",
          },
        }),
        _c("line", {
          staticStyle: {
            fill: "none",
            stroke: "#000",
            "stroke-miterlimit": "10",
            "stroke-width": "2px",
          },
          attrs: { x1: "45.941", y1: "25.986", x2: "53.307", y2: "25.986" },
        }),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }